import React, { useEffect, useRef } from 'react';

interface CustomMapProps {
  className?: string;
}

declare global {
  interface Window {
    google: any;
  }
}

export const CustomMap: React.FC<CustomMapProps> = ({ className }) => {
  const mapRef = useRef<HTMLDivElement>(null);
  const mapInstanceRef = useRef<google.maps.Map | null>(null);

  useEffect(() => {
    const initMap = () => {
      if (!window.google || !mapRef.current || mapInstanceRef.current) {
        return;
      }

      // Coordenadas del local Salbox
      const salboxLocation = { lat: 20.5888, lng: -100.3785 };

      // Inicializar mapa
      const map = new window.google.maps.Map(mapRef.current, {
        center: { lat: 20.6000, lng: -100.3900 }, // Centro más hacia el área de cobertura
        zoom: 11,
        mapTypeId: window.google.maps.MapTypeId.ROADMAP,
      });

      mapInstanceRef.current = map;

      // Marker del local
      const marker = new window.google.maps.Marker({
        position: salboxLocation,
        map: map,
        title: 'Salbox Drive Thru Express',
        icon: {
          path: window.google.maps.SymbolPath.CIRCLE,
          scale: 10,
          fillColor: '#14AEC6',
          fillOpacity: 1,
          strokeColor: '#ffffff',
          strokeWeight: 2,
        },
      });

      // Polígono de cobertura basado en zonas principales de Querétaro
      const coverageCoords = [
        { lat: 20.7300, lng: -100.4600 }, // Juriquilla Noroeste
        { lat: 20.7300, lng: -100.3000 }, // Peña Colorada Este
        { lat: 20.6800, lng: -100.2900 }, // Zibaté Este
        { lat: 20.6400, lng: -100.3100 }, // La Pradera
        { lat: 20.6100, lng: -100.3400 }, // El Campanario Este
        { lat: 20.5500, lng: -100.3500 }, // Centro Sur Este
        { lat: 20.5200, lng: -100.3800 }, // Sur
        { lat: 20.5200, lng: -100.4400 }, // Candiles Sur
        { lat: 20.5600, lng: -100.4600 }, // El Pueblito
        { lat: 20.6200, lng: -100.4800 }, // Cerrito Colorado
        { lat: 20.7000, lng: -100.4700 }, // Juriquilla Oeste
      ];

      // Crear polígono de cobertura
      const coveragePolygon = new window.google.maps.Polygon({
        paths: coverageCoords,
        strokeColor: '#14AEC6',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#14AEC6',
        fillOpacity: 0.15,
      });

      coveragePolygon.setMap(map);

      // Info window para el marker
      const infoWindow = new window.google.maps.InfoWindow({
        content: `
          <div style="padding: 10px; font-family: system-ui, -apple-system, sans-serif;">
            <h3 style="margin: 0 0 8px 0; color: #14AEC6; font-size: 16px;">Salbox Drive Thru Express</h3>
            <p style="margin: 0; font-size: 13px; color: #666;">Av. Corregidora Nte. 485-2<br>Linda Vista, Querétaro</p>
          </div>
        `,
      });

      // Abrir info window al hacer click en el marker
      marker.addListener('click', () => {
        infoWindow.open(map, marker);
      });

      // Cerrar info window al hacer click en el mapa
      map.addListener('click', () => {
        infoWindow.close();
      });
    };

    // Cargar Google Maps API
    if (!window.google) {
      // Verificar si ya existe el script
      const existingScript = document.querySelector(`script[src*="maps.googleapis.com"]`);
      if (!existingScript) {
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&libraries=maps`;
        script.async = true;
        script.defer = true;
        script.onload = initMap;
        script.onerror = () => console.error('Error cargando Google Maps API');
        document.head.appendChild(script);
      }
    } else {
      initMap();
    }

    // Cleanup
    return () => {
      if (mapInstanceRef.current) {
        // Cleanup si es necesario
        mapInstanceRef.current = null;
      }
    };
  }, []);

  return <div ref={mapRef} className={className} style={{ minHeight: '400px', height: '100%', width: '100%' }} />;
};